import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { HttpClient } from '@angular/common/http';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, bmdashboardFilterValue, year } from '../../../models/slakpi';
import { division, department, performancemaster } from '../../../models/admin';
import html2pdf from 'html2pdf.js';
declare var google: any;
@Component({
  selector: 'app-bench-mark-kpi-info',
  templateUrl: './bench-mark-kpi-info.component.html',
  styleUrls: ['./bench-mark-kpi-info.component.css']
})
export class BenchMarkIncomingOutgoingComponent implements OnInit {
  strCurrentYear: any = (new Date()).getFullYear();

  public gridApi;
  public gridColumnApi;
  chartOption: any = {};
  public columnDefs;
  public defaultColDef;
  public rowData: [];
  public businessDivisionUno: any;
  public businessDeptUno: any;
  public trendUno: any;
  public yearUno: any=0;
  public division_data: any;
  public department_data: any;
  public trend_data: any;
  public yearData: any;

  public count_data: any = {};
  public position_data: any=[];
  public peer_data: any=[];
  public bmPeer_data: any=[];
  public map_data: any=[];

  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  kpiUno: any;
  noDataImg: any;
  tenantUno: any;
  peerFilter_Data: any=[];
  peerUno: any='';
  consideration_data: any;
  filter_Data: any = [];
  considerationUno: number = 0;
  source_data: any;
  sourceUno: number = 0;
  strFilter: string = '';
  isStart: boolean = true;
  isPeerChange: boolean = false;
  isSourceChange: boolean = false;
  isfilterChange: boolean = false;
  isConsiderChange: boolean = false;
  onConsiderChange: boolean = true;
  showLine: boolean = false;
    excelObjectData: any=[];
    strsource: string='-';
  strPeer: string = '-';
  strYear: string = '-';
  strFilterItem: any = '-';
  
  strPerformance: any = '-';
  strConsideredBenchmark: any = '-';
  isShowForPdf: boolean = false;
  strOrder: string = '';
  performerData: any = [];
  performerUno: any = 0;
  isHeightCheck: boolean = true;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public _activatedRoute: ActivatedRoute) {
    this.isStart = true;
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin') ? true : false;
    if (!this.isAdmin) {
      //this.CheckUserPermission();
    } else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      //this.yearUno = Number(this.user.currentYear);

    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.isHeightCheck = true;
    this.loadFilterValues();
    //this.getPeer();
    //this.getConsideration();
    //this.getSource();
    this.performerData = [{ displayText: 'Achievement', value: '1' }, { displayText: 'Reduction', value: '2' }]
    this._activatedRoute.params.subscribe((params: Params) => {
      
      this.isStart = true;
      this.isPeerChange = false;
      this.isSourceChange = false;
      if (params['kpiuno'] != null) {
        this.kpiUno = params['kpiuno'];

        this.onLoadDashboard();
      }
    });
  }
  getPeer() {


    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.tableName = 'peer';
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.peerFilter_Data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }
  loadFilterValues() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.yearData = objdata.list_YearMaster;

        //this.onLoadDashboard();

        // this.spinner.hide();
      },
        (error) => {
          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }

  onchangeYear(e) {
    
    //this.yearUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;

    
    let selectedYear = [];

    let selectedStrYear = [];
    for (let item of e) {
      selectedYear.push(item.value);
      selectedStrYear.push(item.text);
    }

    

    this.yearUno = (selectedYear.length == 0) ? "" : selectedYear.toString();
    this.strYear = (selectedStrYear.length == 0) ? "-" : selectedStrYear.toString();
    this.onLoadDashboard();
  }
  onchangePerformer(e) {
    
    this.strOrder = (e && e.length > 0 && e[0].text != null) ? e[0].text : '-';
    this.onLoadDashboard();
  }
  onchangePeer(e) {
    //this.peerUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    
    let selectedPeer = [];

    let selectedStrPeer = [];
    for (let item of e) {
      selectedPeer.push(item.value);
      selectedStrPeer.push(item.text);
    }

    if (selectedPeer.length > 0) {
      this.isPeerChange = true;
    }
    else { this.isPeerChange = false; }
    
    this.peerUno = (selectedPeer.length == 0) ? "" : selectedPeer.toString();
    this.strPeer = (selectedStrPeer.length == 0) ? "-" : selectedStrPeer.toString();
    this.onLoadDashboard();
  }

  onchangeSource(e) {
    

    this.sourceUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.strsource = (e && e.length > 0 && e[0].text != null) ? e[0].text : '-';

    this.isSourceChange = (this.sourceUno > 0) ? true : false;

    this.onLoadDashboard();
  }

  onchangeFilter(e) {
    
    //if (this.strFilter ==null) {
    this.strFilter = (e && e.length > 0 && e[0].text != null) ? e[0].text : '';
    this.strFilterItem = (e && e.length > 0 && e[0].text != null) ? e[0].text : '-';
      this.isfilterChange = (this.strFilter != '') ? true : false;

      this.onLoadDashboard();
    //}
  }

  onchangeConsideration(e) {
    
    
    this.considerationUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.strConsideredBenchmark = (e && e.length > 0 && e[0].text != null) ? e[0].text : '-';
    this.isConsiderChange = (this.considerationUno != 0) ? true : false;
    this.onLoadDashboard();
  }


  public onLoadDashboard() {
    this.spinner.show();
    let inpValue = new bmdashboardFilterValue();
    inpValue.strYearUno = (this.yearUno == 0 || this.yearUno == undefined) ? '' : this.yearUno.toString();
    inpValue.strPeerUno = (this.peerUno == 0 || this.peerUno == undefined) ? '' : this.peerUno.toString();
    inpValue.sourceUno = (this.sourceUno == 0 || this.sourceUno == undefined) ? 0 : this.sourceUno;
    inpValue.considerationUno = (this.considerationUno == 0 || this.considerationUno == undefined) ? 0 : this.considerationUno;
    inpValue.kpiuno = this.kpiUno;
    inpValue.strFilter = (this.strFilter == undefined || this.strFilter=='') ? '' : this.strFilter;
    inpValue.userUno = this.login_UserID;
    inpValue.strOrder = this.strOrder;
    this.spinner.show();
    
    this.restApi.getBMKPIInfo(inpValue)
      .subscribe(data => {
        let objdata: any = data;
        this.count_data = objdata.kpiInfo;
        this.position_data = objdata.positionData;
        this.peer_data = objdata.peerData;
        this.map_data = objdata.mapData;
        this.bmPeer_data = objdata.bmPeerData;

        
        
        //if (this.isStart) {

        //  this.source_data = [];
        //  this.source_data = objdata.dropDownSourceData;

        //  this.isStart = false;
        //}
        if (!this.isSourceChange) {

          this.source_data = [];
          this.source_data = objdata.dropDownSourceData;

          this.isStart = false;
        }
        if (!this.isPeerChange) {
          this.peerFilter_Data = [];
          this.peerFilter_Data = objdata.dropDownPeerData;
        }

        if (!this.isConsiderChange) {
          this.consideration_data = [];
          this.consideration_data = objdata.dropDownConsiderData;
        }

        if (!this.isfilterChange) {
          this.filter_Data = [];
          this.filter_Data = objdata.dropDownFilterData;
        }
        
        

        if (this.bmPeer_data.length > 0) {
          setTimeout(() => {
           
            this.benchmarkincomingoutgoingchart1(this.bmPeer_data,false);
          }, 400);
          }
        if (this.map_data.length > 0) {
          setTimeout(() => {
            google.charts.load('current', {
              'packages': ['geochart'],
              'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
            });
            google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchartworld);
          }, 400);
        }
        //google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchart2);
        

          //google.charts.load('current', {
          //  'packages': ['geochart'],
          //  'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
          //});
          //
          //google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchartworld(this.map_data));
         // google.charts.load('current', { 'packages': ['geochart'], 'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY', 'callback': this.benchmarkincomingoutgoingchartworld(this.map_data) });
          
        
       
        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
          this.isStart = false;
        }
      ).add(() => {
        this.spinner.hide();
      });

  }

 

  benchmarkincomingoutgoingchart1 = (option_data: any, isLine: any) => {
    this.excelObjectData = option_data;
    let tempArray = [];
    for (var i = 0; i < option_data.length; i++) {
      
      //tempArray.push([option_data[i].name, option_data[i].year, parseInt(option_data[i].value)]);
      let value = (option_data[i].value != "0.00" || option_data[i].value !="999999") ? option_data[i].value : "NA";
      tempArray.push([option_data[i].name, option_data[i].year, value]);
    }
    tempArray = tempArray.sort((a, b) => a.year - b.year);
    this.excelObjectData = tempArray;
    

    let legendata = [];
    let seriesdata = [];
    let YearData = [];
    for (var i = 0; i < option_data.length; i++) {
      let tempinnerArr = [];
     // seriesdata.push([option_data[i].name, option_data[i].year, parseInt(option_data[i].value)]);
      if (legendata.indexOf(option_data[i].name) < 0) {
        legendata.push(option_data[i].name);
      }
      if (YearData.indexOf(option_data[i].year) < 0) {
        YearData.push(option_data[i].year);
      }


      //let tempdata: any = seriesdata.filter(item => item.name === option_data[i].name);
      //if (tempdata != null && tempdata != undefined && tempdata.length>0) {
      //  //tempdata[0].data.push(parseInt(option_data[i].value));
      //  tempdata[0].data.push(option_data[i].value);
      //  //tempdata[0]= tempdata;
      //}
      //else {
      //  //tempinnerArr.push(parseInt(option_data[i].value));
      //  tempinnerArr.push(option_data[i].value);
      //  seriesdata.push({
      //    name: option_data[i].name,
      //    type: (isLine && option_data[i].name != 'DEWA Actual' && option_data[i].name != 'DEWA Target') ? 'line':'bar',
      //    data: tempinnerArr,
      //    barWidth: "10%",

      //  },);
      //}

    }
    this.isHeightCheck = legendata.length > 25 ? false : true;
    if (YearData.length > 0) {
      YearData = YearData.sort().reverse();
    }
    
    
    let IslegentActualTarget = 0;
    for (var i = 0; i < legendata.length; i++) {
      //
      if (legendata[i] == 'DEWA Actual' || legendata[i] == 'DEWA Target')
      { IslegentActualTarget = 1; }

      for (var j = 0; j < YearData.length; j++) {

            let tempinnerArr = [];
            let tempdataValue: any = option_data.filter(item => item.name === legendata[i] && item.year === YearData[j]);
            let strValue = 'NA';
            //strValue = (legendata[i] == 'DEWA Actual' || legendata[i] == 'DEWA Target') ? '0' : strValue;

            //if (tempdataValue != null && tempdataValue != undefined && tempdataValue.length > 0) {
            //  strValue = tempdataValue[0].value;
            //  if (legendata[i] == 'DEWA Actual' || legendata[i] == 'DEWA Target') {
            //    strValue = (strValue != '0.00') ? strValue : "0";
            //  } else { strValue = (strValue != '0.00') ? strValue : "NA"; }

            //}

        if (tempdataValue != null && tempdataValue != undefined && tempdataValue.length > 0) {
          strValue = tempdataValue[0].value;
          if (legendata[i] == 'DEWA Actual' || legendata[i] == 'DEWA Target') {
            strValue = (strValue != '999999.00') ? strValue : "NA";
          } else { strValue = (strValue != '999999.00') ? strValue : "NA"; }

        }

            let tempdata: any = seriesdata.filter(item => item.name === legendata[i]);


            if (tempdata != null && tempdata != undefined && tempdata.length>0) {
              
              tempdata[0].data.push(strValue);
            
            }
            else {
              
                tempinnerArr.push(strValue);
                seriesdata.push({
                  name: legendata[i],
                  type: (isLine && legendata[i] != 'DEWA Actual' && legendata[i] != 'DEWA Target') ? 'line' : 'bar',
                  data: tempinnerArr,
                  barWidth: 30,
                  label: {
                    show: true,
                    position: 'inside',
                    size: 16,
                    //color:'red',
                    distance: 50,
                    align: 'left',
                    verticalAlign: 'middle',
                    rotate: 90
                  }
                });
              }
                    
      }
    }

    
    let colorCode = [];

    if (IslegentActualTarget == 1) {
      colorCode = ['#68b097', '#9e9e9e', '#26C6DA', '#64B5F6', '#AED581', '#A1887F', '#B2DFDB',
        '#FDEDEC', '#F4ECF7', '#EAF2F8', '#EBF5FB', '#D0ECE7', '#EAFAF1', '#FDEBD0', '#FBFCFC', '#EAEDED ', '#D5D8DC',
        '#ABEBC6', '#F2D7D5', '#EBDEF0', '#F9EBEA', '#D4E6F1', '#D1F2EB', '#F9E79F', '#F5CBA7', '#EDBB99', '#F7F9F9',
        '#F5B7B1', '#D7BDE2', '#85C1E9', '#73C6B6', '#7DCEA0', '#F8C471', '#E59866', '#D7DBDD', '#B2BABB', '#808B96',
        '#EC7063', '#AF7AC5', '#5499C7', '#48C9B0', '#52BE80', '#F1C40F', '#EB984E', '#F0F3F4', '#99A3A4', '#566573',
        '#922B21', '#76448A', '#2874A6', '#117A65', '#239B56', '#B7950B', '#AF601A', '#A04000', '#B3B6B7', '#616A6B',
        '#78281F', '#512E5F', '#154360', '#0E6251', '#7D6608', '#6E2C00', '#626567', '#4D5656', '#4D5656', '#17202A'];
    } else {
      colorCode = [ '#26C6DA', '#64B5F6', '#AED581', '#A1887F', '#B2DFDB',
        '#FDEDEC', '#F4ECF7', '#EAF2F8', '#EBF5FB', '#D0ECE7', '#EAFAF1', '#FDEBD0', '#FBFCFC', '#EAEDED ', '#D5D8DC',
        '#ABEBC6', '#F2D7D5', '#EBDEF0', '#F9EBEA', '#D4E6F1', '#D1F2EB', '#F9E79F', '#F5CBA7', '#EDBB99', '#F7F9F9',
        '#F5B7B1', '#D7BDE2', '#85C1E9', '#73C6B6', '#7DCEA0', '#F8C471', '#E59866', '#D7DBDD', '#B2BABB', '#808B96',
        '#EC7063', '#AF7AC5', '#5499C7', '#48C9B0', '#52BE80', '#F1C40F', '#EB984E', '#F0F3F4', '#99A3A4', '#566573',
        '#922B21', '#76448A', '#2874A6', '#117A65', '#239B56', '#B7950B', '#AF601A', '#A04000', '#B3B6B7', '#616A6B',
        '#78281F', '#512E5F', '#154360', '#0E6251', '#7D6608', '#6E2C00', '#626567', '#4D5656', '#4D5656', '#17202A'];
    }

    this.chartOption = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: legendata,
        //type: 'scroll',
        orient: 'horizontal',
        bottom: '0',
        width: "100%",
        
        //padding: [
        //  500,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      //color: ['#68b097', '#9e9e9e'],
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      //color: ['#68b097', '#9e9e9e', '#26C6DA', '#64B5F6', '#AED581', '#A1887F', '#B2DFDB',
      //  '#FFCDD2', '#D1C4E9', '#B3E5FC', '#C8E6C9', '#FFECB3',
      //  '#F48FB1', '#BA68C8', '#7986CB', '#26A69A', '#FF7043',
      //  '#4527A0', '#C0CA33', '#FF8F00', '#6D4C41', '#0097A7'],

      color: colorCode,
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: YearData
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      grid: {
        left: '0',
        top: '5%',
        right: '0',
        //bottom: '20%',
        bottom: '275',
       //height:'auto',
        containLabel: true
      },
      dataZoom: [
        {
          show: true,
          start: 1,
          end: (seriesdata.length >10)?30:100,
          right: '2%',
          left: '5%',
          //top: '80%',
          //top: '100%',
          bottom: '225',
          fillerColor: 'rgba(255, 255, 255, 0)',
          borderColor: '#fff',
          //backgroundColor: 'rgba(255, 255, 255, 1)',
          dataBackground: {
            areaStyle: {
              color: 'rgba(255, 255, 255, 1)',
            }
          },
          showDataShadow: false,
          showDetail: false,
          //zoomSelectionColor: '#fff',
          moveHandleSize: 1.
        },


      ],
      series:seriesdata
    };

  }
   
  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    var result = {}, ret = [];
    var newCols = [];
    for (var i = 0; i < dataArray.length; i++) {

      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {};
      }
      result[dataArray[i][rowIndex]][dataArray[i][colIndex]] = dataArray[i][dataIndex];

      //To get column names
      if (newCols.indexOf(dataArray[i][colIndex]) == -1) {
        newCols.push(dataArray[i][colIndex]);
      }
    }

    //newCols.sort(); --Sort by alphabet
    var item = [];

    //Add Header Row
    item.push('Year');
    item.push.apply(item, newCols);
    ret.push(item);

    //Add content 
    for (var key in result) {
      item = [];
      item.push(key);
      for (var i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || 0);
      }
      ret.push(item);
    }

    
    return ret;
  }
  benchmarkincomingoutgoingchart2 = () => {
    let tempArray = [['Peer', 'Value']];
    for (var i = 0; i < this.peer_data.length; i++) {
      tempArray.push([this.peer_data[i].peerName, this.peer_data[i].actualValue]);
    }
    const data = google.visualization.arrayToDataTable(tempArray);

    const options = {

      pieHole: 0.4,
      //colors: ['#339966', '#ffff00', '#ff0000'],
      chartArea: { left: 10, top: 50, bottom: 10, width: "100%", height: "100%" },
      slices: {
        0: { color: '#04bdae' },
        1: { color: '#367cd2' },
        2: { color: '#404041' },
        3: { color: '#68b080' },
        4: { color: '#0b937e' },
        5: { color: '#d5d5d5' },
        6: { color: '#fcba03' },
        7: { color: '#07db0a' },
        8: { color: '#04d4bb' }
      },
      legend: { position: 'left' },
    };

    const chart = new google.visualization.PieChart(document.getElementById('benchmarkincomingoutgoingchart2'));
    chart.draw(data, options);
  }


 

  benchmarkincomingoutgoingchartworld = () => {
    
    let tempArray = [['Country', 'Contribution']];
    for (var i = 0; i < this.map_data.length; i++) {
      
      tempArray.push([this.map_data[i].country, parseInt(this.map_data[i].noofPeer)]);
    }
    
    const data = google.visualization.arrayToDataTable(tempArray);
    /*[
          ['Country', 'Popularity'],
          ['Germany', 200],
          ['United States', 300],
          ['Brazil', 400],
          ['Canada', 500],
          ['France', 600],
          ['RU', 700]
    
        ]*/
    const options = {
      //title: 'DEWA Benchmarking position categories against peers',
      colors: ['#04bdae'],
      chartArea: { width: '80%' },
      //slices: {
      //  0: { color: '#04bdae' },
      //  1: { color: '#367cd2' },
      //  2: { color: '#404041' },
      //  3: { color: '#68b080' },
      //  4: { color: '#0b937e' },
      //  5: { color: '#d5d5d5' },
      //  6: { color: '#fcba03' },
      //  7: { color: '#07db0a' },
      //  8: { color: '#04d4bb' }
      //}

    };

    const chart = new google.visualization.GeoChart(document.getElementById('benchmarkincomingoutgoingchartworld'));
    chart.draw(data, options);
  }
onClickReturn()
{ return false;}



  getConsideration() {
    

    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.tableName = 'consideration';
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.consideration_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }

  getSource() {
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.tableName = 'source';
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.source_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  toggleMenu() {
    this.benchmarkincomingoutgoingchart1(this.bmPeer_data, this.showLine);
  }
  donwloadPeerValue() {
    
    
    let row = this.excelObjectData;//[{ "Name": "Dewa Actual", "Year": "2021","Value":"75" }]
    let header = ["Name", "Year", "Value"]
    this.exportToCsv("BenchmarkChartInfo.csv", row, header);
  }

 exportToCsv = (filename: string, rows: object[], headers?: string[]): void => {
    if (!rows || !rows.length) {
      return;
    }
    const separator: string = ",";

    const keys: string[] = Object.keys(rows[0]);

    let columHearders: string[];

    if (headers) {
      columHearders = headers;
    } else {
      columHearders = keys;
    }

    const csvContent =
      "sep=,\n" +
      columHearders.join(separator) +
      '\n' +
      rows.map(row => {
        return keys.map(k => {
          let cell = row[k] === null || row[k] === undefined ? '' : row[k];

          cell = cell instanceof Date
            ? cell.toLocaleString()
            : cell.toString().replace(/"/g, '""');

          if (navigator.msSaveBlob) {
            cell = cell.replace(/[^\x00-\x7F]/g, ""); //remove non-ascii characters
          }
          if (cell.search(/("|,|\n)/g) >= 0) {
            cell = `"${cell}"`;
          }
          return cell;
        }).join(separator);
      }).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // In case of IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  exportToPDF() {
    
    this.isShowForPdf = true;
    if (this.strYear != '-' || this.strOrder != '-' || this.strPeer != '-' || this.strsource != '-' || this.strPeer != '-' || this.strConsideredBenchmark != '-') {
      this.isShowForPdf = true;
    } else {
      this.isShowForPdf = false;
    }
    var temp = this;
    this.spinner.show();
    window.scroll(0, 0);
    let data: any;
    
    

    data = document.getElementById('divBenchmarkInfo');
    

    let strDate = new Date().getFullYear() + "" + (new Date().getMonth() + 1) + "" + new Date().getDate();


    var opt = {
      margin: 0.5,
      filename: this.count_data.kpiName +'.pdf',
      //filename: 'Chart-' + strDate + '.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2.4, useCORS: true },
      jsPDF: { unit: 'in', format: 'a2', orientation: 'landscape' }

    };

    // New Promise-based usage:
    //html2pdf().from(data).set(opt).save();
    //hd.style.display = 'block';
    
    setTimeout(() => {
      html2pdf().from(data).set(opt).save();
      this.isShowForPdf = false;
      temp.spinner.hide();
    }, 500)
  }

  onClickBack() {
    this.router.navigate(['/benchmarkkpi'], {
      queryParams:{ divisionuno: (this.count_data != null && this.count_data.divisionUno != null) ? this.count_data.divisionUno:0 }
    });
  }
}

